__turbopack_context__.v({
  "button": "userProfileTemplate-module-scss-module__TCzeUW__button",
  "icon": "userProfileTemplate-module-scss-module__TCzeUW__icon",
  "iconOpen": "userProfileTemplate-module-scss-module__TCzeUW__iconOpen",
  "logInBtnSpinner": "userProfileTemplate-module-scss-module__TCzeUW__logInBtnSpinner",
  "logInBtnSpinnerWrapper": "userProfileTemplate-module-scss-module__TCzeUW__logInBtnSpinnerWrapper",
  "loginButton": "userProfileTemplate-module-scss-module__TCzeUW__loginButton",
  "menuArrow": "userProfileTemplate-module-scss-module__TCzeUW__menuArrow",
  "menuContent": "userProfileTemplate-module-scss-module__TCzeUW__menuContent",
  "menuWrapper": "userProfileTemplate-module-scss-module__TCzeUW__menuWrapper",
  "planTag": "userProfileTemplate-module-scss-module__TCzeUW__planTag",
  "userProfileFallbackContainer": "userProfileTemplate-module-scss-module__TCzeUW__userProfileFallbackContainer",
});
